<div class="wrap">
  <div class="content">
    <div class="left-section">
      <div class="logo">
        <div class="link" routerLink="/">
          <img class="brand-logo" ngSrc="{{vars.domainData().logoLightBg}}" width="175" height="72" [alt]="vars.domainData().name" priority />
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="btns">
        @if (vars.pageLayoutConfig().showProfile && !vars.isPermanentLoggedIn()) {
          <button class="signin-btn" (click)="openLogin()" appRipple>Sign in</button>
        }
        @if (vars.pageLayoutConfig().showProfile && vars.isPermanentLoggedIn()) {
          <button class="profile-icon" (click)="onProfileSidebarOpen()" appRipple>
            @if (userData()?.avtar?.cdn_path) {
              <img ngSrc="{{userData()?.avtar?.cdn_path}}" width="49" height="49" alt="{{userData()?.full_name}}">
            }
            @if (!userData()?.avtar?.cdn_path) {
              <em class="material-icons">person</em>
            }
          </button>
        }
      </div>
    </div>
  </div>
</div>

@if (vars.isPermanentLoggedIn()) {
  <app-side-nav />
}

@if (!vars.isPermanentLoggedIn() && showLogin()) {
  <app-component-loader
    selector="app-signin-signup"
    [inputs]="{showClose: true, type: 'modal'}"
    [outputs]="{closed: closeLogin.bind(this)}"
  />
}
